import { usePostTrackEventWithParams } from "./analyticsQueries"

export type TDeviceGraphsAnnotationsEventTypes =
  | "Device Graphs Annotations Enabled"
  | "Device Graphs Annotations Disabled"

export function usePostDeviceGraphsAnnotationEnabledTrackingEvent() {
  return usePostTrackEventWithParams<
    TDeviceGraphsAnnotationsEventTypes,
    { graph_type: "humidity" | "temperature" }
  >({
    event: "Device Graphs Annotations Enabled",
  })
}

export function usePostDeviceGraphsAnnotationDisabledTrackingEvent() {
  return usePostTrackEventWithParams<
    TDeviceGraphsAnnotationsEventTypes,
    { graph_type: "humidity" | "temperature" }
  >({
    event: "Device Graphs Annotations Disabled",
  })
}
